import { useTranslations as useOriginalTranslations } from 'next-intl';

// For future extensions
export function useTranslations(namespace?: string) {
	const t = useOriginalTranslations(namespace);

	return t;
}
